import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "dollar",
  "use": "dollar-usage",
  "viewBox": "0 0 255 448",
  "content": "<symbol viewBox=\"0 0 255 448\" id=\"dollar\"><path d=\"M244.5 296.25c0 51-36.5 91.25-89.5 100V440c0 4.5-3.5 8-8 8h-33.75c-4.25 0-8-3.5-8-8v-43.75C46.75 388 14.75 353 13.5 351.5c-2.5-3-2.75-7.25-.5-10.25l25.75-33.75c1.25-1.75 3.5-2.75 5.75-3s4.5.5 6 2.25c.5.25 35.5 33.75 79.75 33.75 24.5 0 51-13 51-41.25 0-24-29.5-35.75-63.25-49.25-45-17.75-101-40.25-101-103 0-46 36-84 88.25-94V8c0-4.5 3.75-8 8-8H147c4.5 0 8 3.5 8 8v44c50.75 5.75 77.75 33.25 78.75 34.25 2.5 2.75 3 6.5 1.25 9.5l-20.25 36.5c-1.25 2.25-3.25 3.75-5.75 4-2.5.5-4.75-.25-6.75-1.75-.25-.25-30.5-27-68-27-31.75 0-53.75 15.75-53.75 38.5 0 26.5 30.5 38.25 66 52 46 17.75 98 38 98 98.25z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/dollar.svg
// module id = caW8
// module chunks = 1